import axios from "axios";
import * as Constants from "../../utils/Constants";
import { getAuthToken, getClientIdOfUser } from "../../utils/utility";

const setAuthHeader = () => {
  axios.defaults.headers.common["Authorization"] =
    `${Constants.BEARER}${getAuthToken()}`;
};

/**
 * Fetch audit logs for a specific client (CLIENT_ADMIN / CLIENT_MANAGER).
 */
export const fetchClientAuditLogs = async (clientId, filters = {}, pagination = {}) => {
  setAuthHeader();
  const { page = 0, size = 10 } = pagination;
  const params = { page, size, ...buildFilterParams(filters) };
  const url = `${Constants.BASE_URL}${Constants.API_V1}/${clientId}/audit-logs`;
  const response = await axios.get(url, { params });
  return response;
};

/**
 * Fetch all audit logs across tenants (SUPER_ADMIN only).
 */
export const fetchAllAuditLogs = async (filters = {}, pagination = {}) => {
  setAuthHeader();
  const { page = 0, size = 10 } = pagination;
  const params = { page, size, ...buildFilterParams(filters) };
  const url = `${Constants.BASE_URL}${Constants.API_V1}/audit-logs`;
  const response = await axios.get(url, { params });
  return response;
};

/**
 * Convert UI filter state to API query params, omitting empty values.
 */
const buildFilterParams = (filters) => {
  const params = {};
  if (filters.actorId) params.actorId = filters.actorId;
  if (filters.actorUsername && filters.actorUsername.trim())
    params.actorUsername = filters.actorUsername.trim();
  if (filters.action) params.action = filters.action;
  if (filters.entityType) params.entityType = filters.entityType;
  if (filters.entityId) params.entityId = filters.entityId;
  if (filters.status) params.status = filters.status;
  if (filters.from) params.from = filters.from;
  if (filters.to) params.to = filters.to;
  return params;
};

export const AUDIT_ACTIONS = [
  "LOGIN",
  "LOGIN_FAILURE",
  "CREATE",
  "UPDATE",
  "DELETE",
  "STATUS_CHANGE",
  "ASSIGN",
  "UNASSIGN",
  "ACTIVATE",
  "DEACTIVATE",
  "PASSWORD_CHANGE",
  "GENERATE",
  "EXPORT",
  "DEVICE_COMMAND",
  "DEVICE_COMMAND_QUEUED",
  "DEVICE_COMMAND_CANCELLED",
  "DEVICE_COMMAND_DELIVERED",
];

export const AUDIT_ENTITY_TYPES = [
  "User",
  "Client",
  "ClientAsset",
  "Task",
  "Trip",
  "Customer",
  "AssetLabel",
  "AssetPasscode",
  "Report",
];
